export default __webpack_public_path__ + "static/media/virtual-bg14.255e5429.png";